/* --------------------------------------------------------------------------------------
   xwBoundingBox.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/* eslint semi: ["error", "never"]*/
export class xwBoundingBox {
    /* @ngInject*/
    constructor(appSettings) {
        this.restrict = 'A',
        this.appSettings = appSettings
        this.scope = {
            boundingScroll: '<'
        }
    }
    link(scope, elem, attrs) {
        const options = {
            theme: attrs.theme ? attrs.theme : this.appSettings.primaryColor,
            width: attrs.width,
            height: attrs.height,
            boundingScroll: scope.boundingScroll
        }

        elem.first().xrxboundingbox(options)

        scope.$on('$destroy', () => {
            scope = null
        })
        elem.on('$destroy', () => {
            elem.first().xrxboundingbox('destroy')
            elem = null
        })
    }
    static directiveFactory(appSettings) {
        xwBoundingBox.instance = new xwBoundingBox(appSettings)
        return xwBoundingBox.instance
    }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwBoundingBox.directive.js